/**
 * @generated SignedSource<<f57645060e99de4efeb96bb2268df59c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EmployeeWorkStatus = "NOT_WORKING" | "WORKING";
import { FragmentRefs } from "relay-runtime";
export type Avatar_employee$data = {
  readonly image: {
    readonly " $fragmentSpreads": FragmentRefs<"ImagePublicOrPrivate_image">;
  } | null;
  readonly name: string;
  readonly workStatus: EmployeeWorkStatus;
  readonly " $fragmentType": "Avatar_employee";
};
export type Avatar_employee$key = {
  readonly " $data"?: Avatar_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Avatar_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ImagePublicOrPrivate_image"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "1665934dedf609d5dca069d0d368db06";

export default node;
